import axios from 'axios';
import { EquipsServiceAddress } from '../model/constants'
import {HandlerWrapper, HandlerErrorWrapper, GetTokenHeader} from './commonWorker'

const DetTunerController = '/dettuner';

export async function GetTuners(token) {
    return await HandlerWrapper('GetTuners', async () => {
        const response = await axios.get(`${EquipsServiceAddress}${DetTunerController}/GetTuners`, GetTokenHeader(token));
        return response.data;
    });
};

export async function DeleteTuner(token, tunerId) {
    return await HandlerWrapper('DeleteTuner', async () => {
        const response = await axios.delete(`${EquipsServiceAddress}${DetTunerController}/DeleteTuner?tunerId=${tunerId}`, GetTokenHeader(token));
        return response.data;
    });
};

export async function AddTuner(token, data) {
    return await HandlerErrorWrapper('AddTuner', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/AddTuner`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function UpdateTuner(token, data) {
    return await HandlerErrorWrapper('UpdateTuner', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/UpdateTuner`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function GetDetectors(token) {
    return await HandlerWrapper('GetDetectors', async () => {
        const response = await axios.get(`${EquipsServiceAddress}${DetTunerController}/GetDetectors`, GetTokenHeader(token));
        return response.data;
    });
};

export async function DeleteDetector(token, detectorId) {
    return await HandlerWrapper('DeleteDetector', async () => {
        const response = await axios.delete(`${EquipsServiceAddress}${DetTunerController}/DeleteDetector?detectorId=${detectorId}`, GetTokenHeader(token));
        return response.data;
    });
};

export async function AddDetector(token, data) {
    return await HandlerErrorWrapper('AddDetector', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/AddDetector`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function UpdateDetector(token, data) {
    return await HandlerErrorWrapper('UpdateDetector', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/UpdateDetector`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function GetCalibrations(token, detectorId) {
    return await HandlerWrapper('GetCalibrations', async () => {
        const response = await axios.get(`${EquipsServiceAddress}${DetTunerController}/GetCalibrations?detectorId=${detectorId}`, GetTokenHeader(token));
        return response.data;
    });
};

export async function GetBoards(token, boardType = null, boardSN = null) {
    return await HandlerWrapper('GetBoards', async () => {
        const response = await axios.get(`${EquipsServiceAddress}${DetTunerController}/GetBoards?boadrdType=${boardType}&boardSN=${boardSN}`, GetTokenHeader(token));
        return response.data;
    });
};

export async function AddBoard(token, data) {
    return await HandlerErrorWrapper('AddBoard', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/AddBoard`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function UpdateBoard(token, data) {
    return await HandlerErrorWrapper('UpdateBoard', async () => {
        const response = await axios.post(`${EquipsServiceAddress}${DetTunerController}/UpdateBoard`, data, GetTokenHeader(token));
        return response.data;
    });
};

export async function DeleteBoard(token, boardId) {
    return await HandlerWrapper('DeleteBoard', async () => {
        const response = await axios.delete(`${EquipsServiceAddress}${DetTunerController}/DeleteBoard?boardId=${boardId}`, GetTokenHeader(token));
        return response.data;
    });
};